import { isMyAppWKWebView } from "./isMyAppWKWebView";

export async function loadData() {
  if (window.Android) {
    const result = window.Android.loadData();
    if (!result) {
      return;
    }
    return JSON.parse(result);
  }

  if (isMyAppWKWebView()) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return (window.webkit as any).messageHandlers.loadData.postMessage(undefined);
  }

  try {
    const storedData = localStorage.getItem('skillscratch_data');
    if (!storedData) {
      return null;
    }
    return JSON.parse(storedData);
  } catch (error) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    throw new Error(`Failed to load data: ${(error as unknown as any).message || 'Unknown error'}`);
  }
}
